
import { PageResponse } from "../../applications/constants/AppTypes";
import { buildRequestToParams } from "../../applications/utils/StringUtils";
import { ApiClient } from "../api/ApiClient";
import { CreateInventoryLogRequest, FilterInventoryLogRequest, InventoryLogModel } from "../model/InventoryOnHandModel";

const BASE_ULR = "/api/inventory-log";

class InventoryLogServiceClass {

  getListInventoryLog(request: FilterInventoryLogRequest) {
    const params = buildRequestToParams(request);
    return ApiClient.get<PageResponse<InventoryLogModel[]>>(BASE_ULR + `/list?${params}`);
  }

  createImportInventoryLog(request: CreateInventoryLogRequest) {
    return ApiClient.post<InventoryLogModel>(BASE_ULR + `/save`, request);
  }

  deleteInventoryLog(id: number) {
    return ApiClient.delete(BASE_ULR + `/delete/${id}`);
  }
}

const InventoryLogService = new InventoryLogServiceClass();
export default InventoryLogService;